export default __webpack_public_path__ + "static/media/blog_inner_13.53a320d3.jpg";